export function checkBreadcrumbsPosition(): void {
    const breadcrumbs: HTMLElement | null = document.querySelector('.js-breadcrumbs');
    const slider: HTMLElement | null = document.querySelector('.js-sliderPosition');

    if (slider && breadcrumbs) {
        const isSliderOnTop = (slider.getBoundingClientRect().top - breadcrumbs.getBoundingClientRect().bottom) < 10;
        //value 10 is for production!!! for development it have to be less then 100 (NOT 10, because we have in production and development different values)
        if (isSliderOnTop) {
            breadcrumbs.classList.add('breadcrumbs--changePosition');
        }
    }
}
